import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import PlatformHeader from '../appComponents/mobile/PlatformHeader';
import MobileViewport from '../appComponents/mobile/MobileViewport';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import '../appComponents/shared/css/CreditFlowRefinement.css';
import MobileOverlayStyles from '../appComponents/mobile/MobileOverlayStyles';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import PasswordPrompt from '../appComponents/shared/crypto/PasswordPrompt';
import React, { Component } from 'react';

import '../appComponents/mobile/css/MobileExperience.css';
import '../appComponents/mobile/css/MobileDeviceWidth.css';
import '../appComponents/mobile/css/MobileResponsiveViewport.css';

import '../appComponents/mobile/css/MobileDeviceWidthGuard.css';
import './css/NewCreditMobile.css';
import '../appComponents/mobile/css/MobileConsolidated.css';
import '../appComponents/mobile/css/MobileScrollAndBenefits.css';
class NewBorrowingAccountMobileRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Storage, Button, ButtonContent, ButtonGroup, Modal, Header, Image, Container, ListList, ListItem, ListIcon, Icon, Input, ListHeader, ListDescription, ListContent, List, FormField, Form, Radio, Mosaic, OrbitProgress, ThreeDot, LoadingIcons, Link, Fragment, navigationHandler, routeProps, isMobile, ethers, Web3, CryptoJS, mimemessage, awsconfig, deploymentAddressLatest, CampaignContract_latest, CampaignFactoryContract_latest, tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms, LENDERBLOCKADMINWHITELIST, primaryLanguage, mode_light_dark, web3, highRateWeb3, checkValidAuthTokenInterval, cognitoID, currentUser, currentUserCap, primaryDisplayCurrency, secondaryDisplayCurrency, publicKey, corporateBackedUsernamesArray, weiBalance, that, applicantUsername, monthLengtheningEnum, touched, className } = this.props;

    return (
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--new-borrowing-account tbp-platform--mobile tbp-mobile-redesign"}>
<MobileViewport />
<MobileOverlayStyles />

              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            
                    

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.errorTags}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        The Blender Platform
                    </p>
                </Modal.Header>
                
                <Modal.Content image style={{
    justifyContent: 'space-between',
    marginBottom: 0,
    height: 'auto',
    width: '100%',
    position: 'static',
    margin: 0,
    lineHeight: 1.5,
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                    
                    <Modal.Description style={{
      width: '100%',
      height: 'auto',
      position: 'static',
      margin: 0,
      lineHeight: 1.5
    }}>
                        <Header style={{
        // left: '16vw',
        fontSize: 17,
        // position: 'absolute',
        overflowY: 'hidden',
        overflowX: 'hidden',
        width: '100%',
        marginBottom: 0,
        paddingRight: 16,
        height: 'auto',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                            {that.state.selectedLanguage == 'spanish' ? 'Error:' : 'Error:'}
                            </p>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          marginRight: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                            {that.state.errorTags}
                            </p>
                        </Header>
                    
                        <Button content={that.state.selectedLanguage == 'spanish' ? 'Bueno' : 'Okay'}
      // labelPosition='right'
      // icon='checkmark'
      onClick={() => {
        that.setState({
          successfulDepositOverlay: false,
          errorTags: null
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        // left: '0vw',
        borderRadius: 3,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                    </Modal.Description>
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.generalNoticeOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
                
              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <Header style={{
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginRight: 0,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>{`${that.state.generalNoticeText}`}</Header>
                  <Button content="Okay" labelPosition='right' icon='checkmark' onClick={() => {
        that.setState({
          generalNoticeOverlay: false
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>

  
  
              

            <PasswordPrompt
              open={that.state.showPasswordOverlay}
              theme={that.state.mode_light_dark}
              language={that.state.selectedLanguage}
              message={that.state.transactionConfirmationMessage}
              value={that.state.passwordText || ''}
              onChange={(event) => {
                          that.setState({
                            passwordText: event.target.value
                          })
                      }}
              onConfirm={() => {
                        that.setState({
                          showPasswordOverlay: false,
                          pendingTransactionLoaderOverlay: true,
                        })
                        if(that.state.moneyTransactionPreset == 'lend'){
                          that.contributeTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'withdraw'){
                          that.createWithdrawalReqTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'reclaim'){
                          that.rescindTxn(that.state.passwordText)
                        } else if(that.state.moneyTransactionPreset == 'repay'){
                          that.repayTxn(that.state.passwordText)
                        }
                      }}
              onCancel={() => {
                that.setState({
                  showPasswordOverlay: false,
                  passwordText: null,
                  passwordIsHiddenBool: true,
                })
              }}
            />

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.popupBlockerOverlay}
// open={true}
style={{
  justifyContent: 'center',
  alignItems: 'center',
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
                <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                    
                    <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                        {that.state.selectedLanguage == 'spanish' ? `Ventanas Emergentes` : `Pop-Up Windows.`}
                    </p>
                </Modal.Header>
                
                <Modal.Content image style={{
    justifyContent: 'space-between',
    marginBottom: 0,
    height: 'auto',
    width: '100%',
    position: 'static',
    margin: 0,
    lineHeight: 1.5,
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                    
                    <Modal.Description style={{
      width: '100%',
      height: 'auto',
      position: 'static',
      margin: 0,
      lineHeight: 1.5
    }}>
                        <Header style={{
        // left: '16vw',
        fontSize: 20,
        // position: 'absolute',
        overflowY: 'hidden',
        overflowX: 'hidden',
        width: '100%',
        marginBottom: 0,
        paddingRight: 16,
        height: 'auto',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                            <p style={{
          textAlign: 'left',
          textWrap: 'wrap',
          fontWeight: '600',
          fontSize: 16,
          marginRight: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                              {that.state.selectedLanguage == 'spanish' ? `Habilite ventanas "pop-up" del browser para completar tu transacción.` : `Enable Pop-Up tabs and windows to complete your transaction.`}
                            </p>
                        </Header>
                    
                        <Button content={that.state.selectedLanguage == 'spanish' ? 'Bueno' : 'Okay'}
      // labelPosition='right'
      // icon='checkmark'
      onClick={() => {
        that.setState({
          popupBlockerOverlay: false
        });
      }} positive style={{
        backgroundColor: 'rgba(0, 158, 129, 1)',
        // left: '0vw',
        borderRadius: 3,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        width: '100%',
        marginLeft: 0,
        marginRight: 0,
        minHeight: 44,
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
      }} />
                    </Modal.Description>
                </Modal.Content>
            </Modal>

            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.successOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                      The Blender Platform
                  </p>
              </Modal.Header>
              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                {/* <Modal.Description> */}
                  <Header style={{
      position: 'static',
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      paddingRight: 16,
      height: 'auto',
      width: '100%',
      margin: 0,
      lineHeight: 1.5
    }}>
                    
                    <p style={{
        textAlign: 'left',
        textWrap: 'wrap',
        fontWeight: '600',
        fontSize: 16,
        marginRight: 0,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>
                      {that.state.selectedLanguage == 'spanish' ? 'Cuenta Creada!  ' : 'Account Created!  '}
                    </p>
                    <p style={{
        marginTop: 20,
        textAlign: 'left',
        textWrap: 'wrap',
        fontWeight: '600',
        fontSize: 16,
        marginRight: 0,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        lineHeight: 1.5,
        overflowWrap: 'anywhere'
      }}>
                      {that.state.selectedLanguage == 'spanish' ? 'Busque su email en pronto\n para confirmación segunda.' : 'Check your email soon\nfor a second confirmation.'}
                    </p>
                  
                  </Header>
                  <Button content="Okay" labelPosition='right' icon='checkmark' onClick={() => {
      that.setState({
        successOverlay: false
      });
    }} positive style={{
      backgroundColor: 'rgba(0, 158, 129, 1)',
      // position: 'absolute',
      bottom: 0,
      alignSelf: 'center'
      // left: '0vw',
      // right: '13vw',
      ,
      width: '100%',
      marginTop: 0,
      position: 'static',
      minHeight: 44,
      fontSize: 16,
      lineHeight: 1.4,
      boxSizing: 'border-box',
      margin: 0,
      padding: '12px 16px',
      maxWidth: '100%',
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
    }} />
                {/* </Modal.Description> */}
              
                
                </Modal.Content>
            </Modal>

            
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.lowBalanceOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>
                
              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                  <Header style={{
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        marginTop: 0,
        marginRight: 0,
        height: 'auto',
        width: '100%',
        margin: 0,
        lineHeight: 1.5
      }}>
                    <div style={{
          fontSize: 16,
          fontWeight: '600',
          textAlign: 'left',
          textShadowColor: 'rgba(0, 0, 0, 0.10)',
          textShadowOffset: {
            width: -1,
            height: 1
          },
          textShadowRadius: 10,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                      {that.state.selectedLanguage == 'spanish' ? 'Valor Bajo de Cartera Blender\n\n' : 'Low Blender Wallet Balance\n\n'}
                      <p style={{
            fontSize: 14,
            fontWeight: '600',
            textAlign: 'left',
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere'
          }}>
                        {that.state.selectedLanguage == 'spanish' ? 'Querías depositar\npor su tarjeta de banco?' : 'Would you like to top-up\nusing your debit card?'}
                      </p>
                  
                    </div>
                  </Header>




                  <div style={{
        flexDirection: 'row',
        justifyContent: 'center',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto'
      }}>
                  
                    <Button content={that.state.selectedLanguage == 'spanish' ? 'Depositar Fondos' : 'Deposit Funds'} labelPosition='right' icon='checkmark' onClick={() => {
          that.setState({
            lowBalanceOverlay: false,
            inProcessLoading: true
          });
        }} positive style={{
          // marginLeft: 25,
          backgroundColor: 'rgba(0, 158, 129, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%'
        }} />
                    <Button content={that.state.selectedLanguage == 'spanish' ? 'No' : 'No'} labelPosition='right' icon='close' onClick={() => {
          that.setState({
            lowBalanceOverlay: false
          });
        }} positive style={{
          backgroundColor: 'rgba(204, 12, 12, 1)',
          position: 'static',
          top: 'auto',
          left: 'auto',
          right: 'auto',
          bottom: 'auto',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          minHeight: 44,
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%'
        }} />
                  </div>

                </Modal.Description>
              
                
              </Modal.Content>
            </Modal>
            
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={"tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark") + ' tbp-mobile-dialog'} open={that.state.pendingTransactionLoaderOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <Modal.Header style={{
    paddingLeft: 16,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 20,
    width: '100%',
    height: 'auto',
    color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34'
  }}>
                  
                  <p style={{
      textAlign: 'left',
      textWrap: 'wrap',
      fontSize: '17px',
      marginLeft: 0,
      color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
      lineHeight: 1.5,
      overflowWrap: 'anywhere'
    }}>
                    The Blender Platform
                  </p>
              </Modal.Header>

              <Modal.Content image style={{
    padding: 20,
    display: 'block',
    boxSizing: 'border-box'
  }}>
                <Modal.Description style={{}}>
                    <Header style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        marginTop: 0,
        marginBottom: 0,
        height: 'auto',
        width: '100%',
        position: 'static',
        margin: 0,
        lineHeight: 1.5
      }}>
                      <p style={{
          fontSize: 19,
          textAlign: 'left',
          marginBottom: 0,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere'
        }}>
                        {that.state.selectedLanguage == 'spanish' ? "Transacción Pendiente" : "Transaction in Progress"}
                      </p>
                      <div style={{
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0
        }}>
                        <div className="tbp-overlay-loading" style={{}}><ThreeDot color="rgba(0, 158, 129, 1)" size="large" style={{
              maxWidth: '50px',
              speedPlus: -2
            }} /></div>
                      </div>
                    </Header>
                    
                </Modal.Description>
                
                </Modal.Content>
            </Modal>
            
            <Modal centered={false} dimmer={{
  className: "tbp-overlay-backdrop"
}} className={'tbp-mobile-navigation ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark') + ' tbp-mobile-dialog'} open={that.state.navigationOverlay}
// open={true}
style={{
  width: 'calc(100% - 24px)',
  maxWidth: 520,
  height: 'auto',
  minHeight: 0,
  maxHeight: 'calc(100dvh - 32px)',
  overflowY: 'auto',
  overflowX: 'hidden',
  padding: 0,
  margin: '16px auto',
  boxSizing: 'border-box',
  backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
  color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff'
}}
// trigger={<Button>Show Modal</Button>}
>
              <div className="tbp-mobile-menu-panel" style={{
    // borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: '8vh',
    borderRightStyle: 'solid',
    borderWidth: 0.1,
    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
    padding: '20px',
    backgroundColor: that.state.mode_light_dark == 'light' ? '#e0e1e2' : '#282c34',
    border: 0,
    boxSizing: 'border-box',
    position: 'static',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '100%'
  }}><div style={{
      justifyContent: "space-between",
      marginBottom: 24,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      margin: '0 0 20px',
      width: '100%'
    }} className={'tbp-menu-header'}><div style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        textAlign: 'left',
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        flex: 1,
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        width: 'auto',
        minWidth: 0
      }} className={'tbp-menu-brand'}> 
                    <div style={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 12,
          width: 'auto',
          minWidth: 0
        }}>
                      <img src={'https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png'} style={{
            left: '4vw',
            paddingRight: '2vw',
            // position: 'absolute',
            borderRadius: '0.5',
            weight: '3vh',
            position: 'static',
            flexShrink: 0,
            width: 28,
            height: 28,
            flex: '0 0 28px',
            padding: 0,
            margin: 0
          }} />
                      <p style={{
            textAlign: 'left',
            // marginBottom: 5,
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: 0,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            flex: 1,
            minWidth: 0,
            width: 'auto',
            fontSize: 16,
            lineHeight: 1.4,
            overflowWrap: 'normal',
            wordBreak: 'normal',
            margin: 0
          }}>
                        {'The Blender Platform'}
                        <span className="tbp-menu-username" title={String(currentUser || that.state.currentUser || '')}>{'@' + String(currentUser || that.state.currentUser || '').replace(/^@/, '')}</span>
                      </p>
                    </div>

                  </div><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        flexShrink: 0,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        minHeight: 44,
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        maxWidth: '100%',
        width: 44,
        height: 44,
        flex: '0 0 44px',
        padding: 0,
        margin: 0
      }} onClick={() => {
        that.setState({
          navigationOverlay: false
        });
      }}> 
                  <svg className="tbp-mobile-menu-close-svg" aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" /></svg>
                </Button></div><List className="tbp-mobile-menu-list" style={{
      justifyContent: 'space-between',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'stretch',
      height: 'auto',
      width: '100%',
      marginTop: 0,
      marginBottom: 0,
      paddingLeft: 16
    }}>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button" onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/home'
            }
          });
        }}>
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="home icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }} />
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Activos' : 'Accounts'}
                      </p>
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/browser'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="search icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Buscar' : 'Browse'}
                      </p>
                      
                    </button>
                  </ListItem>

                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="newspaper icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Tomar Prestamo' : 'Borrow Funds'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/membertransactions'
            }
          });
        }} style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="wait icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Transacciones' : 'Transactions'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/subscriptionplan'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Blender Pro Plus'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          that.setState({
            navigationOverlay: false,
            navigationDestinationObject: {
              navigationRoute: '/accountmanagement'
            }
          });
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="star icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;  
                        {'Profile'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Condiciones' : 'Terms of Use'}
                      </p>
                      
                    </button>
                  </ListItem>
                  <ListItem style={{
        margin: 0,
        padding: 0,
        width: '100%',
        marginLeft: 0
      }}>
                    <button style={{
          borderWidth: 2,
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',
          textAlign: 'left',
          minHeight: 44,
          width: '100%',
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          position: 'static',
          fontSize: 16,
          lineHeight: 1.4,
          boxSizing: 'border-box',
          margin: 0,
          padding: '12px 16px',
          maxWidth: '100%',
          backgroundColor: that.state.mode_light_dark == 'light' ? '#d1d3d5' : '#484d54',
          border: 0,
          borderRadius: 4
        }} onClick={() => {
          var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
          win.focus();
        }} className="ui huge teal button">
                      <p style={{
            textAlign: 'left',
            fontSize: 16,
            color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
            lineHeight: 1.5,
            overflowWrap: 'anywhere',
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            margin: 0,
            width: '100%'
          }}>
                        <i className="book icon" style={{
              marginRight: 10,
              position: 'static',
              fontSize: 20,
              height: 20,
              lineHeight: 1,
              flexShrink: 0,
              flex: '0 0 22px',
              width: 22,
              margin: 0
            }}></i>
                        &nbsp;
                        {that.state.selectedLanguage == 'spanish' ? 'Privacidad' : 'Privacy Policy'}
                      </p>
                      
                    </button>
                  </ListItem>
                </List><div className="tbp-mobile-menu-actions" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 12,
      borderTop: "1px solid rgba(128,128,128,.25)",
      marginTop: 24,
      paddingTop: 12
    }}><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => {
        trackPageRequest(Auth.signOut());
        that.setState({
          navigationDestinationObject: {
            navigationRoute: '/welcome'
          }
        });
      }}> 
                  <p style={{
          textAlign: 'left',
          fontSize: 16,
          color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
          lineHeight: 1.5,
          overflowWrap: 'anywhere',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          margin: 0,
          width: '100%'
        }}>
                    <i className="sign out icon" style={{
            position: 'static',
            fontSize: 20,
            height: 20,
            lineHeight: 1,
            flexShrink: 0,
            flex: '0 0 22px',
            width: 22,
            margin: 0
          }} />
                    {that.state.selectedLanguage == 'spanish' ? 'Desconectar' : 'Sign Out'}
                  </p>
                </Button><Button style={{
        fontWeight: '600',
        backgroundColor: 'transparent',
        zIndex: 1,
        position: 'static',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        height: 'auto',
        minHeight: 44,
        width: '100%',
        color: that.state.mode_light_dark == 'light' ? '#171717' : '#ffffff',
        fontSize: 16,
        lineHeight: 1.4,
        boxSizing: 'border-box',
        margin: 0,
        padding: '12px 16px',
        maxWidth: '100%'
      }} onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}>
                  <i style={{
          zIndex: 999,
          textAlign: 'left',
          textAlignVertical: 'top',
          // marginBottom: 0, 
          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)'
          // marginLeft: 5,
          ,

          position: 'static',
          fontSize: 20,
          margin: 0,
          width: 20,
          height: 20,
          lineHeight: 1,
          flexShrink: 0
        }} className={that.state.mode_light_dark == 'dark' ? "sun icon" : "moon icon"} />
                </Button></div></div>
            </Modal>  
          

            <div className="tbp-platform__workspace tbp-newcredit-workspace" style={{
              // backgroundColor: 'blue',
              // borderRadius: 10, 
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100dvh',
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              minHeight: 0,
              maxWidth: '100%',
              // borderStyle: 'none',
              borderWidth: 0,    
              position: 'relative',
              left: '0vw',
              top: 0,
              backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              // border: 'none',   
              // borderColor: 'rgba(177, 177, 177, 0)',
            }}>
            
              <PlatformHeader
                  title={that.state.selectedLanguage === 'spanish' ? 'Nueva línea de crédito' : 'New Credit Line'}
                  language={that.state.selectedLanguage}
                  onHome={() => that.setState({ navigationDestinationObject: { navigationRoute: '/home' } })}
                  onMenu={() => that.setState({ navigationOverlay: true })}
                />
              
              <div className="tbp-platform__body tbp-mobile-newcredit-body" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10,
                justifyContent: 'start',
                alignItems: 'center',
                width: '100%',
                height: 'auto',
                minHeight: 0,
                flex: '1 1 auto',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                margin: 0,
                borderStyle: 'none',
                borderWidth: 0,
                backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
              }}>
                <div className="tbp-newcredit-main-scroll"
                  // class="scrollNoScrollBar"
                  style={{
                    // borderRadius: 10,
                    // backgroundColor: 'red',
                    justifyContent: 'start',
                    alignItems: 'center',
                    width: '100%',
                    maxWidth: '100%',
                    position: 'relative',
                    left: '0vw',
                    // top: 0, 
                    // bottom: 0, 
                    height: 'auto',
                    minHeight: 0,
                    flex: '1 1 auto',
                    paddingBottom: 'min(12vh, 96px)',
                    WebkitOverflowScrolling: 'touch',
                    marginTop: 0,
                    marginBottom: 0,
                    marginRight: 0,
                    marginLeft: '0vw',
                    borderStyle: 'none',
                    borderWidth: 0,
                    scrollbarWidth: 'none',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                    // backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                  }}
                >







                              <div className="tbp-mobile-newcredit-intro"
                                style={{
                                  width: '94vw',
                                  height: '15vh',
                                  flexDirection: 'row',
                                  display: 'flex',
                                  borderRadius: 3,
                                  borderColor: 'rgba(177, 177, 177, 1)',
                                  justifyContent: 'space-between',
                                  borderColor: 'red',
                                  marginLeft: '3vw',

                                }}
                              >
                                <p 
                                  style={{ 
                                    textAlign: 'left',
                                    textAlignVertical: 'center',
                                    fontSize: 18, 
                                    fontWeight: '600', 
                                    color: 'rgba(0, 158, 129, 1)',
                                    marginTop: '1vh', 
                                    marginBottom: 30,
                                    // textUnderlineOffset: 3, 
                                    // textDecorationLine: 'underline', 
                                    // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                  }}
                                >
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Bienvenido a Crédito de Blender!  '
                                      :
                                    'Welcome to Blender Credit!  '
                                  }
                                  
                                  <p
                                    style={{
                                      textAlign: 'left',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      fontSize: 13, 
                                      fontWeight: '400', 
                                    }}
                                  >
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      'El crecer su propia'
                                        :
                                      'Creating your own'    
                                    }
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      ' Línea de Crédito Blender '
                                        :
                                      ' Blender Credit Line '
                                    }
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      'es una acción fundamental y gratificante por crecer economías a través de la sociedad.'
                                        :
                                      'is a rewarding and fundamental action towards the creation of socio-economics.'
                                    }
                                    &nbsp;                                    
                                    &nbsp;
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      'Participe hoy.'
                                        :
                                      'Take part today.'
                                    }
                                  </p>
                                  
                                </p>
                              </div>

                              <div
                                className="tbp-newcredit-fields" style={{
                                  width: '94vw',
                                  height: '27vh',
                                  flexDirection: 'row',
                                  display: 'flex',
                                  borderRadius: 3,
                                  borderColor: 'rgba(177, 177, 177, 1)',
                                  justifyContent: 'space-between',
                                  marginLeft: '3vw',
                                  marginTop: '2vh',
                                  // backgroundColor: 'red',
                                }}
                              >
                          
                                <div className="tbp-newcredit-field tbp-newcredit-field--rate"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '47vw',
                                    height: '35vh',
                                  }}
                                >
                                  <p 
                                    style={{ 
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      fontSize: 13, 
                                      // fontWeight: '600', 
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      marginTop: 0, 
                                      marginBottom: 30,
                                      height: 50,
                                      width: '47vw',
                                      paddingRight: '2vw',
                                      // textUnderlineOffset: 3, 
                                      // textDecorationLine: 'underline', 
                                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                    }}
                                  >
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      'Establezca la tasa de interés anual a cual se capitalizará su deuda.'
                                        :
                                      'Set the Annual Interest Rate at which your debt will compound.'
                                    }
                                  </p>
                                  <p className="tbp-newcredit-unit"
                                    style={{
                                      position: 'absolute',
                                      top: '30vh', 
                                      left: '77vw',
                                      fontSize: 30,
                                      fontWeight: '600',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 1)',
                                    }}
                                  >
                                    {'%'}
                                  </p>
                                  <input className="tbp-newcredit-input" 
                                    type="text" 
                                    id="text" 
                                    outline="none"
                                    autocomplete="off"
                                    onChange={(event) => {
                                        that.setState({
                                          intRate_commOffer_Input: Number(event.target.value).toFixed(0)
                                        })
                                    }} 
                                    name="text"
                                    maxLength={2}
                                    placeholder={`${Number(that.state.intRate_commOffer_Input).toFixed(0)}`} 
                                    disabled={that.state.readyForFinalizationBool}
                                    style={{
                                      fontWeight: '600',
                                      fontFamily: 'arial',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                      paddingLeft: '5vw',
                                      paddingTop: '3vw',
                                      paddingBottom: '3vw',
                                      paddingRight: '3vw',
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      fontSize: 18,
                                      height: '17vh',
                                      width: '46vw',
                                      borderRadius: 0,
                                      borderStyle: 'none',
                                      borderWidth: 0,
                                      fontSize: 80,
                                      marginRight: '1vw',
                                      borderColor: 'rgba(177, 177, 177, 0)',
                                      backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                    }}
                                  />
                                </div>

                                <div className="tbp-newcredit-field tbp-newcredit-field--minimum"
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '47vw',
                                    height: '35vh',
                                  }}
                                >
                                  <p 
                                    style={{ 
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      fontSize: 13, 
                                      // fontWeight: '600', 
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                      marginTop: 0, 
                                      marginBottom: 30,
                                      height: 50,
                                      width: '47vw',
                                      paddingLeft: '2vw',
                                      // textUnderlineOffset: 3, 
                                      // textDecorationLine: 'underline', 
                                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                    }}
                                  >
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      "Eliga el pago mínimo que pagarás a més mientras estas en buen estatus de pagar. "
                                        :
                                      "Set the Minimum Repayment you'll pay each month to keep your account up-to-date." 
                                    }
                                  </p>

                                  <p className="tbp-newcredit-unit"
                                    style={{
                                      position: 'absolute',
                                      top: '30vh', 
                                      left: '37vw',
                                      fontSize: 30,
                                      fontWeight: '600',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 1)',
                                    }}
                                  >
                                    {'USD'}
                                  </p>
                                  <input className="tbp-newcredit-input" 
                                    type="text" 
                                    id="text" 
                                    outline="none"
                                    autocomplete="off"
                                    disabled={that.state.readyForFinalizationBool}
                                    maxLength={2}
                                    onChange={(event) => {
                                        that.setState({
                                          minLoanInput: Number(event.target.value).toFixed(0)
                                        })
                                    }} 
                                    name="text"
                                    placeholder={`${Number(that.state.minLoanInput).toFixed(0)}`} 
                                    style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                        padding: '3vw',
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        fontSize: 18,
                                        height: '17vh',
                                        width: '46vw',
                                        borderRadius: 0,
                                        borderStyle: 'none',
                                        borderWidth: 0,
                                        fontSize: 80,
                                        marginLeft: '1vw',
                                        borderColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                      }}
                                  />
                                </div>


                              </div>

                              <section className="tbp-newcredit-review" aria-label={that.state.selectedLanguage === 'spanish' ? 'Resumen de tu línea de crédito' : 'Credit line summary'}>
                                <div className="tbp-newcredit-costs">
                                  <h3>{that.state.selectedLanguage === 'spanish' ? 'Resumen de costos' : 'Credit Line Summary'}</h3>
                                  <div className="tbp-newcredit-cost-row tbp-newcredit-cost-row--total">
                                    <span>{that.state.selectedLanguage === 'spanish' ? 'Total adeudado' : 'Total Due'}</span>
                                    <strong>{`${(Number(that.state.targetValue) + Number(that.state.flatRateFIATCostConversion)).toFixed(2)} USD`}</strong>
                                  </div>
                                  <div className="tbp-newcredit-cost-row">
                                    <span>{that.state.selectedLanguage === 'spanish' ? 'Colateral inicial' : 'Initial Collateral'}</span>
                                    <strong>{`${Number(that.state.targetValue).toFixed(2)} USD`}</strong>
                                  </div>
                                  <div className="tbp-newcredit-cost-row">
                                    <span>{that.state.selectedLanguage === 'spanish' ? 'Costo de creación' : 'Creation Fee'}</span>
                                    <strong>{`${Number(that.state.flatRateFIATCostConversion).toFixed(2)} USD`}</strong>
                                  </div>
                                </div>
                                <div className="tbp-newcredit-agreement">
                                  <h3>{that.state.selectedLanguage === 'spanish' ? 'Acuerdo del prestatario' : "Borrower's Agreement"}</h3>
                                  <div className="tbp-newcredit-agreement-text">{that.state.agreementTextObj}</div>
                                </div>
                              </section>

                              <div
                                className="tbp-newcredit-actions" style={{
                                  width: '94vw',
                                  height: '8vh',
                                  display: 'flex',
                                  flexDirection:  'row',
                                  borderRadius: 3,
                                  borderColor: 'rgba(177, 177, 177, 1)',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  marginTop: '0vh',
                                  paddingLeft: 0,
                                  paddingRight: 0,
                                  marginLeft: '3vw',
                                  position: 'relative',

                                  // backgroundColor: 'blue'
                                }}
                              >
                                <Button className="tbp-newcredit-primary" 
                                  onClick={() => {

                                    if(Number(that.state.minLoanInput) >= 1 && Number(that.state.intRate_commOffer_Input) >= 1){
                                      that.setState({
                                        readyForFinalizationBool: true,
                                      })
                                      that.setAgreementTextObj()

                                    } else {
                                      that.setState({
                                        readyForFinalizationBool: false,
                                        errorTags:
                                          <p
                                            style={{
                                              textAlign: 'left',
                                            }}
                                          >
                                            {that.state.selectedLanguage == 'spanish' ? 
                                              'Pago Mensual Minimo o Tasa de Interés se está bajo.'
                                              :
                                              'Minimum Monthly Repayment or Annual Interest Rate is too low.'
                                            }
                                          </p>
                                      })
                                    }
                                  }}
                                  style={{
                                    width: '40vw',
                                    height: '8vh',
                                    marginRight: '3vw',
                                    borderRadius: 0, 
                                    borderColor: 'rgba(256, 256, 256, 1)',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 9999,
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                  }}
                                  disabled={that.state.readyForFinalizationBool}
                                >                  
                                  <p 
                                    style={{ 
                                      fontSize: 19, 
                                      textAlign: 'center', 
                                      position: 'relative', 
                                      textAlignVertical: 'top', 
                                      fontWeight: '600', 
                                      marginBottom: 5, 
                                      color: 'rgba(0, 158, 129, 1)',
                                    }}
                                  > 
                                  {that.state.selectedLanguage == 'spanish' ? 
                                      'Confirmar'
                                        :
                                      'Confirm'
                                    }
                                  </p>
                                </Button>

                                <Button className="tbp-newcredit-secondary" 
                                  onClick={() => {
                                    that.setState({
                                      readyForFinalizationBool: false,
                                      minLoanInput: null,
                                      intRate_commOffer_Input: null,
                                    })
                                  }}
                                  style={{
                                    width: '40vw',
                                    height: '8vh',
                                    borderRadius: 0, 
                                    borderColor: 'rgba(256, 256, 256, 1)',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 9999,
                                    marginRight: 0,
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                  }}
                                >                  
                                  <p 
                                    style={{ 
                                      fontSize: 19, 
                                      textAlign: 'center', 
                                      position: 'relative', 
                                      textAlignVertical: 'top', 
                                      fontWeight: '600', 
                                      marginBottom: 5, 
                                      color: 'rgba(235, 50, 38, 1)',
                                    }}
                                  > 
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      'Cancelar'
                                        :
                                      'Cancel'
                                    }
                                  </p>
                                </Button>

                              </div>

                              <div className="tbp-newcredit-publish"
                                style={{
                                  width: '94vw',
                                  height: '8vh',
                                  borderRadius: 3,
                                  borderColor: 'rgba(177, 177, 177, 1)',
                                  alignItems: 'center',
                                  marginTop: '3vh',
                                  marginBottom: '3vh',
                                  paddingLeft: 0,
                                  marginLeft: '3vw',
                                  position: 'relative',
                                }}
                              >
                                <Button
                                  disabled={!that.state.readyForFinalizationBool}
                                  onClick={() => {

                                    if((Number(weiBalance) <= (Number(that.state.flatRateWeiCostConversion) + (Number(Number(that.state.targetValue).toFixed(0) + '000000000000000000'))))){
                                      that.setState({
                                        lowBalanceOverlay: true,
                                        inProcessLoading: true,
                                      })
                                    } else {
                                      that.setState({ 
                                        showPasswordOverlay: true,
                                        transactionConfirmationMessage: `Publish your credit line.  Your Blender Wallet will be charged ${((Number(that.state.targetValue))/1 + Number(that.state.flatRateFIATCostConversion)).toFixed(2)} USD.`,
                                        inProcessLoading: true,
                                      })
                                    }
                                  }}
                                  style={{
                                    width: '94vw',
                                    height: '8vh',
                                    // borderTopLeftRadius: '10px',
                                    // borderBottomLeftRadius: '10px',
                                    borderColor: 'rgba(177, 177, 177, 0)',
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginLeft: 0, 
                                    marginRight: 0,
                                    paddingLeft: 10, 
                                    paddingRight: 10,
                                    borderRadius: 0,
                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                                  }}
                                >
                                  <p
                                    style={{
                                      color: 'rgba(0, 158, 129, 1)', 
                                      textAlign: 'center',
                                      textAlignVertical: 'center',
                                      fontSize: 19,
                                      fontWeight: '600',
                                    }}
                                  >
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      'Publicar tu Línea de Crédito'
                                      :
                                      'Publish Your Credit Line'
                                    }
                                  </p>
                                </Button>
                              </div>

                           

                  


              <PlatformFooter language={that.state.selectedLanguage} mobile />
              </div> {/* End content scroller: footer follows Publish button */}
              </div> {/* End mobile body */}
            </div>
          </div>
    );
  }
}

export default NewBorrowingAccountMobileRender;
